<!-- Header which is shown on all sreens except the login screen -->
<header *ngIf="isHeaderActive" class="header">
    <div class="navigation">
        <app-sidebar></app-sidebar>

        <img class="header__logo" src="/assets/img/Automation/small-logo.png" alt="Optimus logo" />

        <h1 class="header__title">{{ moduleName }}</h1>

        <app-topbar></app-topbar>

        <!-- Refresh button does nothing at the moment -->
        <button class="header__refresh-button"></button>
    </div>

    <!-- <input #selection type="hidden" /> -->
</header>

<main (scroll)="onScroll($event)" [ngClass]="{ 'module-wrapper': isHeaderActive, 'module-wrapper_expanded': !isSidebarExpanded }">
    <router-outlet></router-outlet>
</main>

<p-messages class="messages"></p-messages>
